import React, { useState } from "react";

import { Button } from "../../Components/Basic/Button";
import { formSteps } from "./Steps/index";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Footer from "../../Components/Footer";
import { Loader } from "../../Components/Basic";
import { useAppContext } from "../../Store/store";
import { useHistory } from "react-router-dom";

import firebase from "firebase";
import "firebase/functions";

const intialValues = {
  // qualify questions
  separated_12m: "",
  aust_citizen_requirement: "",
  aust_live_indefinitely_requirement: "",
  aust_live_12m_requirement: "",
  marriage_over: "",

  //user email
  user_email: "",

  //page 1

  marriage_date: "", //date
  separation_date: "",
  marriage_cert_if_get: "",
  marriage_place: "", //Australia or Overseas
  marriage_cert_if_english: "",

  //page 2
  joint_divorce: "", // Myself or Joint
  ex_address_if_known: "", // y, n
  ex_address_if_overseas: "", // y, n, unsure
  ex_if_post_respond: "", // y, n, unsure
  lived_apart_12m: "", // y, n

  // not in use
  marriage_less2_if_counselling: "",
};

// NOTE: There is a firebase call in QualifyResults step.

const FormNavigationButtons = ({
  isFirst,
  handleBackClick,
  onStartOver,
  currentStep,
}) => {
  return (
    <section className={`flex h-12 items-center mt-2`}>
      {isFirst ? (
        <div
          className="w-10/12 cursor-pointer"
          onClick={() => handleBackClick()}
        >
          <KeyboardBackspaceIcon />
        </div>
      ) : (
        <div
          className="flex-1 w-4/12 cursor-pointer"
          onClick={() => handleBackClick()}
        >
          <KeyboardBackspaceIcon fontSize="large" />
        </div>
      )}

      <Button
        type="submit"
        fontSize="lg"
        form="divorce-form"
        className="flex-9 w-6/12  md:max-w-xs mx-3 md:mx-0 focus:outline-none p-4 bg-nativeBlue-200 hover:bg-nativeBlue-300  hover:border-nativeBlue-300"
      >
        {currentStep === 6 ? "Submit" : "Next"}
      </Button>
    </section>
  );
};

function DivorceForm() {
  // this state keeps track what step the form is up to.
  const [currentStep, setCurrentStep] = useState(0);
  //this is a JSX component
  const CurrentQuest = formSteps[currentStep];

  // this is used to keep track of the form data that is saved
  const [formData, setFormData] = useState(intialValues);
  const [loader, setloader] = useState(false);

  // this is the global context. This is where the priceData will be stored.
  const { contextState, setContextState } = useAppContext();
  //first and last

  // this is the for navigation
  const history = useHistory();

  // this is used for display logic for next and back button

  const navigationDontShow =
    currentStep === 1 || currentStep === 2 || currentStep === 5;

  //firebase
  const db = firebase.firestore();

  const onSubmit = async (FormData) => {
    console.log("onsubmit", FormData);

    console.log("currentStep", currentStep);

    if (currentStep === 1) {
      setloader(true);
      setTimeout(() => {
        setFormData((prevData) => ({ ...prevData, ...FormData }));
        setCurrentStep(currentStep + 1);
        setloader(false);
        window.scrollTo(0, 0);
      }, 3005);
    }
    //
    else if (currentStep === 3) {
      savetoFirebase(FormData);
      setFormData((prevData) => ({ ...prevData, ...FormData }));
      setCurrentStep(currentStep + 1);
    }

    //
    else if (currentStep === 4) {
      //this will be sent to server.
      setloader(true);
      try {
        const calcPrice = firebase.functions().httpsCallable("calcPrice");
        const response = await calcPrice(FormData);
        setContextState(response);

        setTimeout(() => {
          setFormData((prevData) => ({ ...prevData, ...FormData }));
          setCurrentStep(currentStep + 1);
          setloader(false);
          window.scrollTo(0, 0);
        }, 2856);

        //put into context
      } catch (error) {
        alert("An error occurred");
        setloader(false);
      }
    } else if (currentStep === 6) {
      setloader(true);
      setTimeout(() => {
        setFormData((prevData) => ({ ...prevData, ...FormData }));
        savetoFirebase(FormData);
        sendMKINotice(FormData);
        setloader(false);
        history.push("/thank-you");
      }, 2150);
    }

    //
    else {
      setFormData((prevData) => ({ ...prevData, ...FormData }));
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const handleBackClick = () => {
    if (currentStep > 0 && currentStep <= Object.keys(formSteps).length) {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0);
    }
  };

  const savetoFirebase = async (saveData) => {
    try {
      await db
        .collection("divorceAssessment")
        .doc(saveData?.user_email)
        .set({ ...saveData, ...contextState });

      // this notifies MKI of new assessment.
    } catch (e) {
      console.log("error occurred");
    }
  };

  const sendMKINotice = async (saveData) => {
    let emailMKI = await fetch(
      "https://hooks.zapier.com/hooks/catch/1569300/b45je0g/",
      {
        method: "post",
        // headers: {
        //   Accept: "application/json",
        //   "Content-type": "application/json",
        // },
        body: JSON.stringify({
          user_email: saveData?.user_email,
          message: "A New Divorce Assessment Was Received ",
          phone: saveData?.user_phone,
        }),
      }
    );
  };

  return (
    <div className="h-screen relative">
      {loader ? (
        <Loader />
      ) : (
        <>
          <CurrentQuest onSubmit={onSubmit} store={formData} />

          {navigationDontShow ? null : (
            <section className="mx-auto w-5/6 md:w-2/3 lg:w-1/2 xl:w-1/3 pt-16 pb-20">
              <FormNavigationButtons
                currentStep={currentStep}
                handleBackClick={handleBackClick}
              />
            </section>
          )}

          <section>
            <Footer />
          </section>
        </>
      )}
    </div>
  );
}

export default DivorceForm;
